import { render } from "./AddToRoomPopup.vue?vue&type=template&id=1ed89e22&ts=true"
import script from "./AddToRoomPopup.vue?vue&type=script&lang=ts"
export * from "./AddToRoomPopup.vue?vue&type=script&lang=ts"

import "./AddToRoomPopup.vue?vue&type=style&index=0&id=1ed89e22&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__